import { adminListingQueryKeys as e } from "./adminListingQueryKeys.mjs";
import { useInfiniteList as t, useInfiniteQuery as n } from "@maat/store-hooks";
import { adminListingsApi as r } from "@maat/api-main";
//#region src/listings/admin/useAdminModerationImagesQuery.ts
var i = 25, a = (a = "all", o) => t(n({
	queryKey: e.moderation(a, o),
	queryFn: ({ pageParam: e }) => r.listModerationImages({
		status: a,
		workspace_id: o,
		limit: i,
		offset: e
	}),
	initialPageParam: 0,
	getNextPageParam: (e, t) => e.hasMore ? t.length * i : void 0
}), "images");
//#endregion
export { a as useAdminModerationImagesQuery };
